import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useAuth } from '../utils/AuthContext'; // Assuming you have an AuthContext for managing authentication

const Dashboard: React.FC = () => {
  const { logout } = useAuth(); // Use the logout function from AuthContext

  const handleLogout = () => {
    logout(); // Clear authentication state
  };

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <Typography variant="h4">Welcome to the Dashboard</Typography>
      <Typography variant="body1">You are successfully logged in!</Typography>
      <Button variant="contained" color="primary" onClick={handleLogout}>
        Logout
      </Button>
    </Box>
  );
};

export default Dashboard;